module.exports = __webpack_public_path__ + "static/icons/icon-beneficios-desbloqueado1.8b4ff52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icon-beneficios-desbloqueado1.svg
// module id = fsWx
// module chunks = 1